import PasswordResetForm from 'components/PasswordResetForm';
import React, { useState } from 'react';
import LoginForm from '../LoginForm';
import RegisterForm from '../RegisterForm';

export enum Forms {
  'LoginForm',
  'RegistrationForm',
  'ForgotPasswordForm',
}

interface RegwallProps {
  registrationTitle: string;
  registrationText: string;
  defaultForm?: Forms;
}

const Regwall: React.FC<RegwallProps> = ({
  registrationTitle,
  registrationText,
  defaultForm = Forms.RegistrationForm,
}) => {
  const [shownForm, setShownForm] = useState(defaultForm);

  const switchToRegForm = () => {
    setShownForm(Forms.RegistrationForm);
  };

  const switchToLoginForm = () => {
    setShownForm(Forms.LoginForm);
  };

  const switchToForgotPasswordForm = () => {
    setShownForm(Forms.ForgotPasswordForm);
  };

  return (
    <>
      {shownForm === Forms.LoginForm && (
        <LoginForm showRegForm={switchToRegForm} showPassResetForm={switchToForgotPasswordForm} />
      )}
      {shownForm === Forms.RegistrationForm && (
        <RegisterForm
          registrationTitle={registrationTitle}
          registrationText={registrationText}
          showLoginForm={switchToLoginForm}
        />
      )}
      {shownForm === Forms.ForgotPasswordForm && <PasswordResetForm showLoginForm={switchToLoginForm} />}
    </>
  );
};

export default Regwall;
